import { createContext } from "react";

import { StackContextTypes } from "./Types";

export const StackContext = createContext<StackContextTypes | undefined>(undefined);
StackContext.displayName = "StackContext";
